import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';
import { useTenantConfig } from './useTenantConfig';

export interface SnowflakeTableOption {
  name: string;
  schema_name: string;
  database_name: string;
  rows: number;
}

export type ListRecordsResponse<T> = {
  records: T[];
  total_pages?: number;
  total_records?: number;
};

/**
 * Listing tables runs SHOW DATABASES/TABLES/VIEWS against the tenant's Snowflake,
 * which wakes the warehouse. Callers must pass `enabled` only when the table list
 * is actually about to be shown.
 */
export function useAvailableSnowflakeTables({ enabled = true }: { enabled?: boolean } = {}) {
  const tenantConfig = useTenantConfig();
  
  return useQuery<SnowflakeTableOption[]>({
    queryKey: ['snowflake_tables', tenantConfig.data?.id || 'no-id'],
    queryFn: async () => {
      if (!tenantConfig.data || (tenantConfig.data as any).database !== 'SNOWFLAKE') {
        return [];
      }
      const results = await ApiService.getInstance().request(
        'GET',
        `/tenant-config/${tenantConfig.data.id}/get-snowflake-tables`
      ) as ListRecordsResponse<SnowflakeTableOption>;
      return results.records;
    },
    enabled: enabled && !!tenantConfig.data && (tenantConfig.data as any).database === 'SNOWFLAKE',
    staleTime: 60 * 1000 * 30, // 30 minutes
  });
}

